export default {"src":"/_next/static/media/logo-and-text-on-light.7e5d5c4e.svg","height":34,"width":220,"blurWidth":0,"blurHeight":0};